import { PureComponent } from 'react';
import { Container } from 'reactstrap';
import withMobileAppMode from '../Layout/withMobileAppMode';

const DAY_COUNT = 22;

class TimelinePlaceholder extends PureComponent {
  repeat = (times, func) => {
    const result = [];
    for (let i = 0; i < times; i += 1) {
      result.push(func(i));
    }
    return result;
  };

  render() {
    return (
      <div className="timeline-container hidden">
        <section className="timeline placeholder-glow">
          <Container>
            <nav>
              <div className="timeline-arrow left">
                <span className="SVGInline">{this.props.leftArrow}</span>
              </div>
              <div className="timeline-arrow right">
                <span className="SVGInline">{this.props.rightArrow}</span>
              </div>

              <ul>
                {this.repeat(DAY_COUNT, (key) => (
                  <li className="nav-item" key={key}>
                    <span className="nav-link placeholder" tabIndex="-1" role="presentation">
                      &nbsp; <br />
                      &nbsp;
                    </span>
                  </li>
                ))}
              </ul>
            </nav>
          </Container>
        </section>
      </div>
    );
  }
}

export { TimelinePlaceholder };
export default withMobileAppMode(TimelinePlaceholder);
